
var app = angular.module('directives.breadcrumbs', []);

require('./directives/breadcrumbs.js');
require('./templates/breadcrumbs.html');
require('./stylesheets/index.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/breadcrumbs/index.js
 ** module id = 137
 ** module chunks = 1
 **/